class EventEmitter {
  constructor() {
    this._events = {};
  }

  addEventListener(type, handler) {
    if (this._events.hasOwnProperty(type) === false) {
      this._events[type] = [];
    }

    this._events[type].push(handler);
  }

  removeEventListener(type, handler) {
    if (this._events.hasOwnProperty(type) === false) {
      return;
    }

    const index = this._events.indexOf(handler);
    this._events.splice(index, 1);
  }

  hasListeners(type) {
    if (this._events.hasOwnProperty(type) === false) {
      return false;
    }

    return this._events[type].length > 0;
  }

  emit(e) {
    if (e.hasOwnProperty('type') === false) {
      return;
    }

    if (this._events.hasOwnProperty(e.type) === false) {
      return;
    }

    const eventsOfType = this._events[e.type];
    for (let i = 0; i < eventsOfType.length; i++) {
      eventsOfType[i](e);
    }
  }
}

export default EventEmitter;
